export default {
  background_image: 'Hintergrundbild',
};
